import { render, staticRenderFns } from "./CompaniesWpsDetail.vue?vue&type=template&id=0121083d&scoped=true"
import script from "./CompaniesWpsDetail.vue?vue&type=script&lang=js"
export * from "./CompaniesWpsDetail.vue?vue&type=script&lang=js"
import style0 from "./CompaniesWpsDetail.vue?vue&type=style&index=0&id=0121083d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0121083d",
  null
  
)

export default component.exports